import { FC } from 'react';
import { Container, Divider } from '@chakra-ui/react';

import { ArticleMetaData } from 'lib/shared/types/ArticleMetaData';
import { getLayout } from 'layouts/SiteOuterLayout';

import {
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  OL,
  UL,
  LI,
} from 'lib/shared/contentRenderers';

export type SectionProps = {
  children: React.ReactNode;
};

export const Section: FC<SectionProps> = ({ children }: SectionProps) => (
  <Container
    maxW="container.xl"
    mb={5}
    padding={10}
    borderRadius={20}
    backgroundColor="gray.100"
  >
    {children}
  </Container>
);

export type PostPageProps = {
  article: ArticleMetaData;
};

export default function StyleGuidePage() {
  return (
    <>
      <H1>CITJS StyleGuide</H1>

      <Divider mb={5} mt={5} />

      <Section>
        <H1>H1: The quick brown fox jumped over the lazy dogs.</H1>
        <H2>H2: The quick brown fox jumped over the lazy dogs.</H2>
        <H3>H3: The quick brown fox jumped over the lazy dogs.</H3>
        <H4>H4: The quick brown fox jumped over the lazy dogs.</H4>
        <H5>H5: The quick brown fox jumped over the lazy dogs.</H5>
        <H6>H6: The quick brown fox jumped over the lazy dogs.</H6>
      </Section>

      <Section>
        <UL>
          <LI>Unordered list item 1</LI>
          <LI>Unordered list item 2</LI>
          <LI>Unordered list item 3</LI>
          <LI>Unordered list item 4</LI>
          <LI>Unordered list item 5</LI>
        </UL>

        <OL>
          <LI>Ordered list item 1</LI>
          <LI>Ordered list item 2</LI>
          <LI>Ordered list item 3</LI>
          <LI>Ordered list item 4</LI>
          <LI>Ordered list item 5</LI>
        </OL>
      </Section>
    </>
  );
}

StyleGuidePage.getLayout = (page) =>
  getLayout(<Container maxW="container.xl">{page}</Container>);
